import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { DR2008Pdf } from '../../shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2008-pdf';
import { DR2008CompPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2008Comp-pdf';
import { DR2009Pdf } from '../../shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2009-pdf';
import { DestinacaoReserva2008Component } from './destinacao-reserva-2008/destinacao-reserva-2008.component';
import { DestinacaoReserva2009Component } from './destinacao-reserva-2009/destinacao-reserva-2009.component';
import { DestinacaoReservaComplet2008Component } from './destinacao-reserva-complet-2008/destinacao-reserva-complet-2008.component';
import { DestinacaoReservaMenorIgual2012Component } from './destinacao-reserva-menor-igual-2012/destinacao-reserva-menor-igual-2012.component';
import { DestinacaoReservaRoutingModule } from './router/destinacao-reserva.router';
import { DestinacaoReservaService } from './service/destinacao-reserva.service';
import { ErrorsModule } from '../../shared/error/error.module';


@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        DestinacaoReservaRoutingModule,
        ErrorsModule
    ],
    declarations: [
        DestinacaoReserva2008Component,
        DestinacaoReserva2009Component,
        DestinacaoReservaMenorIgual2012Component,
        DestinacaoReservaComplet2008Component,
    ],
    providers: [
        DR2008Pdf,
        DR2008CompPdf,
        DR2009Pdf,
        DestinacaoReservaService
    ]
})
export class DestinacaoReservaModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/destinacao-reserva/destinacao-reserva.module.ts